export default __webpack_public_path__ + "static/media/ate4.f1578ae8.png";